import HttpResponse from "../../../../utils/http/http.response";

export enum MileageDetailsResponseVehicleType {
  COMPANY_OWNED = "COMPANY_OWNED",
  CAR_GT_900CM3 = "CAR_GT_900CM3",
  CAR_LE_900CM3 = "CAR_LE_900CM3",
  MOTORCYCLE = "MOTORCYCLE",
  MOPED = "MOPED",
}

export type MileageDetailsResponseAddressSequenceNode = {
  lat: number;
  lon: number;
  displayName: string;
  zipCode?: string;
  town?: string;
  street?: string;
  houseNumber?: string;
  apartmentNumber?: string;
  distance?: number;
};

export type MileageDetailsResponseAddressSequence = {
  seq: MileageDetailsResponseAddressSequenceNode[];
};

export type MileageDetailsResponseItem = {
  id: string;
  workerCompanyId: string;
  mileageDate: Date;
  cardNumber?: string | null;
  commissionNumber?: string | null;
  mileageNumber?: string | null;
  vehicleType: MileageDetailsResponseVehicleType;
  distance: number;
  workerName: string;
  addressSeq: MileageDetailsResponseAddressSequence;
  acceptedDistance?: number;
  osrmDistance?: number;
};

type MileageDetailsResponse = HttpResponse<MileageDetailsResponseItem>;

export default MileageDetailsResponse;
